import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const FormFunnelTrustBadge = ({ text }: { text: string }) => (
  <Box
    data-testid="form-funnel-trust-badge"
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      // FlowForm supplies a 16px row gap; offset it by 2px for the design's
      // exact 14px spacing below either Continue or the final option list.
      mt: "-2px",
      color: "secondary.dark",
      textAlign: "center",
    }}
  >
    <Box sx={{ color: "success.main", flexShrink: 0, fontSize: "0.9rem", lineHeight: 1 }}>
      <FontAwesomeIcon icon={faCircleCheck} aria-hidden="true" />
    </Box>
    <Typography
      component="span"
      sx={{ minWidth: 0, fontSize: "0.9rem", lineHeight: 1.5 }}
    >
      {text}
    </Typography>
  </Box>
);
